export const instrumentationSchema = {
  scenario: [
    {
      name: 'adsGrid',
      value: 'Ads Grid',
      activity: [
        {
          name: 'fetchRejectionReason',
          value: 'Fetch Rejection Reason',
        },
        {
          name: 'loadRSAAssetReportLink',
          value: 'Load RSA Asset Report Link',
        },
        {
          name: 'adStrength',
          value: 'RSA ad strength',
        },
      ],
    }],
};
